import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { getHeaderHeight } from '~/utilities/getHeaderHeight';
import { AppDataContext } from '~/contexts/AppDataContext';
import { ArticleContext } from '~/contexts/ArticleContext';
import { useIsSI } from '~/utilities/useIsSI';
import { hasFanSidedAds } from '~/utilities/experiments/fanSidedVideoAds';

export default component$((): JSX.Element => {
  const {
    themeComponents,
    payloadToSSR: { layout },
  } = useContext(AppDataContext);
  const isSI = useIsSI();

  const article = useContext(ArticleContext);
  const appData = useContext(AppDataContext);

  if (!article) return <></>;

  return (
    <div
      style={{
        marginTop:
          article.finiteScrollNumber === 0
            ? getHeaderHeight(themeComponents, layout, {
                isSI,
                add: !hasFanSidedAds(appData.property) ? 20 : 0,
              })
            : 0,
      }}
    >
      <Slot />
    </div>
  );
});
